import { initReactI18next } from "react-i18next";
import i18next from "i18next";

// Common
import enCommon from "./locales/common/en.json";
import esCommon from "./locales/common/es.json";

import enLogin from "../pages/login/locales/en.json";
import esLogin from "./../pages/login/locales/es.json";
import enRegister from "../pages/register/locales/en.json";
import esRegister from "../pages/register/locales/es.json";
import enPurchase from "../pages/purchase/locales/en.json";
import esPurchase from "../pages/purchase/locales/es.json";
import enUseCases from "../components/useCase/locales/en.json";
import esUseCases from "../components/useCase/locales/es.json";
import enOnboarding from "../pages/onboarding/locales/en.json";
import esOnboarding from "../pages/onboarding/locales/es.json";
import enLinkDevice from "../pages/devices/link/locales/en.json";
import esLinkDevice from "../pages/devices/link/locales/es.json";
import enAdminSections from "../Layouts/admin/locales/en.json";
import esAdminSections from "../Layouts/admin/locales/es.json";
import enFinanzasOperativas from "../Layouts/finanzas-operativas/locales/en.json";
import esFinanzasOperativas from "../Layouts/finanzas-operativas/locales/es.json";

import enHome from "../pages/home/locales/en.json";
import esHome from "../pages/home/locales/es.json";
import enLite from "../Layouts/lite/locales/en.json";
import esLite from "../Layouts/lite/locales/es.json";
import enEntregaServicio from "../Layouts/entrega-servicio/locales/en.json";
import esEntregaServicio from "../Layouts/entrega-servicio/locales/es.json";

// Session Reset
import enSessionReset from "../pages/public/confirm-session-reset/locales/en.json";
import esSessionReset from "../pages/public/confirm-session-reset/locales/es.json";

// Password Reset
import enPasswordReset from "../pages/public/reset-password/locales/en.json";
import esPasswordReset from "../pages/public/reset-password/locales/es.json";

// Reseller Admin
import enAccess from "../pages/access/locales/en.json";
import esAccess from "../pages/access/locales/es.json";
import enResellerAdmin from "../Layouts/reseller-admin/locales/en.json";
import esResellerAdmin from "../Layouts/reseller-admin/locales/es.json";

// Truck Yard (Patios de Maniobras)
import enTruckYard from "../pages/patios-maniobras/locales/en.json";
import esTruckYard from "../pages/patios-maniobras/locales/es.json";

// Nuvex Access — consola de control de acceso y videovigilancia (CC-CONSOLE #1593)
import enAccessConsole from "../Layouts/nuvex-access/locales/en.json";
import esAccessConsole from "../Layouts/nuvex-access/locales/es.json";
// Control de estacionamientos (CC-CONSOLE #1594)
import enParking from "../Layouts/nuvex-access/parking/locales/en.json";
import esParking from "../Layouts/nuvex-access/parking/locales/es.json";

// XML

import enSupport from "../pages/support/locales/en.json";
import esSupport from "../pages/support/locales/es.json";

import enServiceDesk from "../Layouts/service-desk/locales/en.json";
import esServiceDesk from "../Layouts/service-desk/locales/es.json";

// Envios
import enEnvios from "../Layouts/envios/locales/en.json";
import esEnvios from "../Layouts/envios/locales/es.json";

// SG

// Respaldos
import enRespaldos from "../pages/respaldos/locales/en.json";
import esRespaldos from "../pages/respaldos/locales/es.json";

// Gastos — estados de cuenta del banco (#952 – #955)
import enExpensesStatements from "../Layouts/expenses/locales/en.json";
import esExpensesStatements from "../Layouts/expenses/locales/es.json";
// Bases y Propiedades + Rondines (CC-CONSOLE #1592)
import enBases from "../Layouts/bases-propiedades/locales/en.json";
import esBases from "../Layouts/bases-propiedades/locales/es.json";

// Activos (épica común CC-CONSOLE ↔ WAYAK, #1638)
import enActivos from "../Layouts/activos/locales/en.json";
import esActivos from "../Layouts/activos/locales/es.json";

// Radar de Correo
import enRadarCorreo from "../Layouts/radar-correo/locales/en.json";
import esRadarCorreo from "../Layouts/radar-correo/locales/es.json";

// Documentación — expediente documental de embarques (CC-CONSOLE #1632)
import enDocumentacion from "../Layouts/documentacion/locales/en.json";
import esDocumentacion from "../Layouts/documentacion/locales/es.json";

// Tienda pública (/shop/:slug): misma preferencia de idioma que la consola
import enStore from "../pages/public/store/locales/en.json";
import esStore from "../pages/public/store/locales/es.json";

// Cargo Market — flujo del interesado desde la landing (CC-CONSOLE#1639)
import enCargoMarket from "../Layouts/cargo-market/locales/en.json";
import esCargoMarket from "../Layouts/cargo-market/locales/es.json";

const LANGUAGE_STORAGE_KEY = "app-language-preference";

function getStoredLanguage(): string {
  if (typeof window === "undefined") return "es";
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored === "en" || stored === "es") return stored;
  return "es";
}

i18next.use(initReactI18next).init({
  compatibilityJSON: "v4",
  lng: getStoredLanguage(),
  fallbackLng: "es",
  resources: {
    en: {
      common: enCommon,
      login: enLogin,
      register: enRegister,
      // Alta self-service: vuelta del pago
      purchase: enPurchase,
      // Casos de uso (CC-CONSOLE #1611): registro, perfil y límites del plan
      useCases: enUseCases,
      // Bienvenida guiada tras el registro y el pago (#1019)
      onboarding: enOnboarding,
      // Vincular dispositivo (CC-CONSOLE#1523)
      linkDevice: enLinkDevice,
      adminSections: enAdminSections,
      // Cotizador de costos operativos + Finanzas operativas (transportistas)
      finanzasOperativas: enFinanzasOperativas,
      // Home
      home: enHome,
      lite: enLite,
      // Entrega de Servicio
      entregaServicio: enEntregaServicio,
      // Session Reset
      sessionReset: enSessionReset,
      // Password Reset
      passwordReset: enPasswordReset,
      // Reseller Admin
      access: enAccess,
      resellerAdmin: enResellerAdmin,
      // Truck Yard (Patios de Maniobras)
      truckYard: enTruckYard,
      accessConsole: enAccessConsole,
      parking: enParking,
      // XML
      // Support
      support: enSupport,
      // Service Desk
      serviceDesk: enServiceDesk,
      // Envios
      envios: enEnvios,
      // SG
      // Respaldos
      respaldos: enRespaldos,
      // Gastos — estados de cuenta del banco
      expensesStatements: enExpensesStatements,
      bases: enBases,
      activos: enActivos,
      // Radar de Correo
      radarCorreo: enRadarCorreo,
      // Documentación (expediente documental)
      documentacion: enDocumentacion,
      // Tienda pública
      store: enStore,
      // Cargo Market (bolsa: carga elegida, verificación, demostración)
      cargoMarket: enCargoMarket,
    },
    es: {
      common: esCommon,
      login: esLogin,
      register: esRegister,
      // Alta self-service: vuelta del pago
      purchase: esPurchase,
      useCases: esUseCases,
      // Bienvenida guiada tras el registro y el pago (#1019)
      onboarding: esOnboarding,
      linkDevice: esLinkDevice,
      adminSections: esAdminSections,
      finanzasOperativas: esFinanzasOperativas,
      // Home
      home: esHome,
      lite: esLite,
      // Entrega de Servicio
      entregaServicio: esEntregaServicio,
      // Session Reset
      sessionReset: esSessionReset,
      // Password Reset
      passwordReset: esPasswordReset,
      // Reseller Admin
      access: esAccess,
      resellerAdmin: esResellerAdmin,
      // Truck Yard (Patios de Maniobras)
      truckYard: esTruckYard,
      accessConsole: esAccessConsole,
      parking: esParking,
      // XML
      // Support
      support: esSupport,
      // Service Desk
      serviceDesk: esServiceDesk,
      // Envios
      envios: esEnvios,
      // SG
      // Respaldos
      respaldos: esRespaldos,
      // Gastos — estados de cuenta del banco
      expensesStatements: esExpensesStatements,
      bases: esBases,
      activos: esActivos,
      // Radar de Correo
      radarCorreo: esRadarCorreo,
      // Documentación (expediente documental)
      documentacion: esDocumentacion,
      // Tienda pública
      store: esStore,
      cargoMarket: esCargoMarket,
    },
  },
});

// Persist language changes to localStorage (salvo un cambio sin guardar, ver abajo).
let persistLanguage = true;
i18next.on("languageChanged", (lng: string) => {
  if (!persistLanguage) return;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    /* almacenamiento bloqueado */
  }
});

/**
 * Cambia el idioma SIN guardarlo como preferencia. La tienda pública lo usa
 * cuando el idioma sale del navegador (nadie lo eligió): así no fija la
 * preferencia de la consola en el mismo origen. Con recursos empaquetados,
 * `languageChanged` se emite de forma síncrona dentro de `changeLanguage`.
 */
function changeLanguageWithoutPersisting(lng: string) {
  persistLanguage = false;
  try {
    return i18next.changeLanguage(lng);
  } finally {
    persistLanguage = true;
  }
}

export default i18next;
export { LANGUAGE_STORAGE_KEY, getStoredLanguage, changeLanguageWithoutPersisting };
